module.exports = __webpack_public_path__ + "media/site/images/coffeetime/coffeetime-header-adfd505e0f7577b0818c9cf8d316deb6.svg";